import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { CoreUserRelation } from "../../../models/CoreUser";
import StatusCode from "../../../util/StatusCode";
import TableHorizontal from "../../misc/TableHorizontal";
import * as Helper from '../../../util/Helper';
import { GetUserRelations } from "../../../store/UserAction";
import { RequestState } from "../../../models/RequestState";
import { InfoObject } from "../../misc/TableHorizontalPagedToggle";
import { useTranslation } from "react-i18next";
import { RootState } from "../../../store/store";



const UserViewUserRelations = () => {
    const { t } = useTranslation(['common', 'schoolAdministration']);

    const { userId } = useParams();
    const dispatch = useDispatch();
    const relations = useSelector<RootState, RequestState<CoreUserRelation[]>>(state => state.users.userRelation);

    useEffect(() => {
        if (userId !== undefined) {
            GetUserRelations(userId)(dispatch);
        }
    }, [dispatch, userId]);

    const mapRelations = (): InfoObject[] => {
        if (relations.code !== StatusCode.COMPLETE) {
            return [];
        }

        return relations.data.map(ur => ({
            id: ur.id,
            data: [
                { value: <Link to={`/user/${ur.userId}`}>{ur.displayName}</Link> },
                { value: ur.schoolUnit ? <Link to={`/schoolunit/${ur.schoolUnit.id}`}>{ur.schoolUnit.title}</Link> : '' },
                { value: ur.isChild ? t(`childRelationTypes.${ur.relationType}`, { ns: 'schoolAdministration' }) : t(`parentRelationTypes.${ur.relationType}`, { ns: 'schoolAdministration' }) },
                { value: Helper.active(ur.active) },
            ]
        }))
    }

    const renderUserRelations = () => {
        const relationsInfo = mapRelations();
        return (
            <TableHorizontal
                header={[{ value: t('genericTableHeaders.name', { ns: 'common' }) }, { value: t('commonTableHeaders.schoolUnit', { ns: 'schoolAdministration' }) }, { value: t('commonTableHeaders.relation', { ns: 'schoolAdministration' }) }, { value: t('genericTableHeaders.active', { ns: 'common' }) }]}
                info={relationsInfo}
                searching={relations.code === StatusCode.PENDING}
                error={relations.code === StatusCode.ERROR}
                displayName={t('userViewUserRelations.userRelations', { ns: 'schoolAdministration' })}
                noResMsg={t('userViewUserRelations.noResult', { ns: 'schoolAdministration' })}
            />
        );
    }

    return (<>
        {renderUserRelations()}
    </>)
}

export default UserViewUserRelations;
